import { proxy } from "valtio";
import { esaTokenService } from "./esaTokenService";
import axios, { AxiosError } from "axios";
import { esaApiEndpoint } from "../utils/env";
import { generalLogicService } from "./generalLogicService";
import { DashboardContact } from "types/contact.types";

class EsaContactService {
  handleError = (error: AxiosError) => {
    if (error.response) {
      const { status, data } = error.response;
      const errorMessage = error.message;

      const serverError = status >= 500;
      if (serverError) {
        generalLogicService.setError({
          status,
          message: errorMessage,
          type: "critical",
        });
      }
    }
  }

  async submitForm(value: DashboardContact){
    value.Token = esaTokenService.get();
    const payload = JSON.stringify(value);
    const meta = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const response = await axios.post(
      `${esaApiEndpoint}/Client/submitcontactrequest`,
      payload,
      meta
    ).catch((error)=>{
      this.handleError(error);
    });
  }
}

export const esaContactService = proxy(new EsaContactService());
